module.exports = __webpack_public_path__ + "static/media/riderModel.823e99bd.png";